import Vue from 'vue';
import config from '../../config/index';

export default {
  // 查询字典类型列表
  getDictList(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysDictType/page`, { params });
  },
  // 新增字典类型
  postNewDictType(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysDictType/add`, params);
  },
  // 编辑字典类型
  postEditDictType(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysDictType/edit`, params);
  },
  // 删除字典类型
  postDeleteDictType(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysDictType/delete`, params);
  },
  // 查询字典值列表
  getDictDataList(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysDictData/page`, { params });
  },
  // 新增字典值
  postNewDictData(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysDictData/add`, params);
  },
  // 编辑字典值
  postEditDictData(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysDictData/edit`, params);
  },
  // 删除字典值
  postDeleteDictData(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysDictData/delete`, params);
  }
};
